import React from "react";

/**
 * PartnerHorizontalStack component
 * This component is used to display a horizontal stack of partners.
 * Each partner is represented by an icon and a link to their respective page.
 *
 * @param {Object} data - The data for the component
 * @returns {JSX.Element} - Rendered component
 */
const PartnerHorizontalStack = ({ data }) => {
    // Destructure data object
    const { customId, title, subtitle, description, cta = [] } = data ?? {};

    // Render the component
    return (
        // Section container
        <section data-section className="bg-stone-light pt-15 pb-5 scroll-mt-45 lg:pt-30 lg:pb-15" id={customId}>
            <div className="container">
                <div className="row justify-center">
                    <div className="col-10">
                        {/* Title */}
                        {title && <h2 className="mb-5 text-center">{title}</h2>}
                        {/* Description */}
                        {description?.description && (
                            <p className="text-center body-big mb-7.5 lg:mb-[78px]">{description?.description}</p>
                        )}
                    </div>
                </div>
                <div className="row gap-y-5 lg:gap-y-7.5">
                    {/* Subtitle */}
                    {subtitle && (
                        <div className="col-12">
                            <h3 className="title-4 text-center">{subtitle}</h3>
                        </div>
                    )}
                    {/* CTA */}
                    {cta?.map(
                        (partner) =>
                            // Ensure partner icon URL exists
                            partner?.icon?.[0]?.secure_url && (
                                <div className="col-6 md:col-3" key={partner.id}>
                                    <div>
                                        <a
                                            href={
                                                partner.internalLink
                                                    ? `/${partner.internalLink.slug}`
                                                    : partner.externalUrl
                                            }
                                            target={partner.browsingContext === "New Tab" ? "_blank" : "_self"}
                                            rel={!partner.internalLink ? "noreferrer" : ""}
                                            className="block group/partner-wrapper contain-paint"
                                        >
                                            {/* Partner Icon */}
                                            <img
                                                src={partner?.icon?.[0]?.secure_url}
                                                alt={partner?.icon?.[0]?.context?.custom.alt}
                                                className="aspect-square w-full lg:transition-all lg:duration-500 lg:ease-in-out lg:group-hover/partner-wrapper:scale-105"
                                            />
                                        </a>
                                    </div>
                                </div>
                            )
                    )}
                </div>
            </div>
        </section>
    );
};

// Export the PartnerHorizontalStack component
export default PartnerHorizontalStack;
